import type { IState } from '~/src/features/videocontrol/Provider/types';

interface ISelect {
    state: IState,
    isPerMonth?: boolean,
    withOutSale?: boolean,
}

const selectPrice = ({ state, isPerMonth = false, withOutSale = false }: ISelect): number => {
    const { cameras, installLocation, plan, planOption, injector } = state;
    let totalPrice = 0;
    const camerasArray = Object.values(cameras);
    camerasArray.forEach((camera) => {
        isPerMonth && (totalPrice += camera.priceMonthWithCount);
        !isPerMonth && (totalPrice += camera.priceTotalWithCount + camera.priceMonthWithCount);
    });
    !isPerMonth && installLocation && (totalPrice += installLocation.priceTotalWithCount);
    !isPerMonth && injector.count && (totalPrice += injector.priceTotalWithCount);
    plan && !withOutSale && (totalPrice += plan.priceMonthWithCount);
    plan && withOutSale && (totalPrice += Number(plan.oldPrice) || plan.priceMonthWithCount);
    planOption && (totalPrice += planOption.priceMonthWithCount);
    return totalPrice;
};

export const selectTotalPrice = (state: IState): number => {
    return selectPrice({ state });
};

export const selectTotalPriceMonth = (state: IState): number => {
    return selectPrice({ state, isPerMonth: true });
};

export const selectTotalPriceWithOutSale = (state: IState): number => {
    return selectPrice({ state, withOutSale: true });
};
